/* @flow */
import { flatten } from 'lodash';
import liferay from 'services/liferay';
import type { AsyncAction, OnDemand, Track, WorklistItem } from 'types';
import protonesUtils from '../../utils/protones';

const onFailure = (error: Object) => console.warn(error);

const submitQuotationRequest = (request: OnDemand): AsyncAction => {
  const worklistItems = (request.quotation && request.quotation.worklistItems) || [];
  const quotationPromises = worklistItems.map(worklistItem => {
    const mergedComponents = (worklistItem.mergedComponents || []).filter(
      protonesUtils.getCanAskQuotationForLicenseComponent
    );
    const components = flatten(mergedComponents.map(c => c.components || []));
    return liferay.worklists.askQuotation({
      worklistItemId: worklistItem.id,
      rightIds: components.map(c => c.right.id),
    });
  });
  return {
    type: 'SUBMIT_QUOTATION_REQUEST_REQUEST',
    payload: request,
    promise: Promise.all(quotationPromises),
    meta: { onFailure, successMessage: 'Richiesta effettuata con successo' },
  };
};

const submitOnDemandRequest = (request: OnDemand): AsyncAction => {
  if (request.type === 'QUOTATION') {
    return submitQuotationRequest(request);
  }
  //$FlowFixMe
  return {
    type: 'SUBMIT_ON_DEMAND_REQUEST_REQUEST',
    payload: request,
    promise: liferay.onDemand.submit(request),
    meta: { onFailure, successMessage: 'Richiesta effettuata con successo' },
  };
};

const askTracks = (tracks: Track[]) => {
  return {
    type: 'ON_DEMAND_ASK_TRACKS',
    payload: tracks,
  };
};

const askQuotation = (worklistItems: WorklistItem[]) => {
  return {
    type: 'ON_DEMAND_ASK_QUOTATION',
    payload: worklistItems,
  };
};

const askSmartlist = () => {
  return {
    type: 'ON_DEMAND_ASK_SMARTLIST',
    payload: null,
  };
};

export default {
  submitOnDemandRequest,
  askQuotation,
  askTracks,
  askSmartlist,
};
